import { render, staticRenderFns } from "./LoginConsent.vue?vue&type=template&id=2c96d558&scoped=true"
import script from "./LoginConsent.vue?vue&type=script&lang=ts"
export * from "./LoginConsent.vue?vue&type=script&lang=ts"
import style0 from "./LoginConsent.vue?vue&type=style&index=0&id=2c96d558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96d558",
  null
  
)

export default component.exports